<template>
  <div class="modal-overlay" style="white-space: pre-line">
    <div class="modal-card">
      
      <!-- Header -->
      <div class="modal-header primary">
        <h6 class="modal-title">{{ title }}</h6>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <p class="modal-message">{{ message }}</p>

        <v-divider class="my-5"></v-divider>

        <div class="modal-actions">
          <v-btn
            @click="$emit('yes')"
            color="success"
            class="btn-confirm"
            depressed
          >
            Sim
          </v-btn>

          <v-btn
            @click="$emit('close-modal')"
            outlined
            color="error"
            class="btn-cancel"
          >
            Não
          </v-btn>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: String
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);

  z-index: 9999;
  padding: 16px;
}

.modal-card {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;

  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.25);
  transform: translateY(-4px);
}

.modal-header {
  background: var(--v-primary-base);
  padding: 16px 20px;
}

.modal-title {
  margin: 0;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.2px;
}

.modal-body {
  padding: 20px;
}

.modal-message {
  margin: 0;
  color: #444;
  font-size: 15px;
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-confirm,
.btn-cancel {
  min-width: 110px;
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
}
</style>
